import Section from '@/components/integrated/section';
import { CalloutBanner } from '@alto-avios/alto-ui';
import { useMicrocopyContext } from '@/context/microcopy/microcopy-context';

const GenericErrorSection = () => {
  const microcopy = useMicrocopyContext();

  return (
    <Section>
      <CalloutBanner
        title={microcopy.general_errorsection_title}
        description={microcopy.general_errorsection_description}
        styleVariant="information"
        emphasis="secondary"
      />
    </Section>
  );
};

export default GenericErrorSection;
